module.exports = __webpack_public_path__ + "img/upload-icon.35aa31d1.svg";